(ns frontend.view.nev.kyc.process.info-editor)

(defn editor [{:keys [lang-kw question-meta]}]
  [:div
   [:label.input-editor__label.pb-2 (some-> question-meta :translations (get lang-kw))]])
